import axios from 'axios'
import {message} from 'antd'
axios.defaults.withCredentials = true;
export default function ajax(url, data = {}, type = 'GET') {

    return new Promise((resolve, reject) => {
        let promise
        // 1. 执行异步ajax请求
        if (type === 'GET') { // 发GET请求
            promise = axios.get(url, { // 配置对象
                params: data // 指定请求参数
            })
        } else if (type === 'POST') { // 发POST请求
            promise = axios.post(url, data)
        } else if (type === 'PUT') { // 发PUT请求
            promise = axios.put(url, data)
        } else if (type === 'PATCH') { // 发PATCH请求
            promise = axios.patch(url, data)
        } else if (type === 'DELETE') { // 发DELETE请求
            promise = axios.delete(url, {params: data})
        }else if (type === 'DELETE2') { // 发DELETE请求
            promise = axios.delete(url, {data: data})
        }
        // 2. 如果成功了, 调用resolve(value)
        promise.then(response => {
            resolve(response.data)
            // 3. 如果失败了, 不调用reject(reason), 而是提示异常信息
        }).catch(error => {
            reject(error)
            message.error('请求出错了: ' + error.message)
        })
    })


}

